$(document).ready(function() {
	
	//replace timeplaceholder
	replaceTimePlaceHolder();
	
	var toggleSpeed = 600;
	
	$('.search_icon').click(function(event) {
		
		//prevent heading to the <a> url
		event.preventDefault();

		var $clickedElement = $(this);

		//Switch between + and - (only used in bigsearchmode)
		//now also switches correctly from smallsearchmode
		if ( $clickedElement.is('a, div') ) {
			if ( $('#advancedsearch_div').is(':hidden') ) {
				$('.header_searchbuttonsdiv > .search_icon').html('-');
				$('.smallsearchmode > .search_icon').html('');
			} else {
				$('.header_searchbuttonsdiv > .search_icon').html('+');
				$('.smallsearchmode > .search_icon').html('');
			}
		}

		$('#advancedsearch_div').fadeToggle(toggleSpeed, 'linear');
	});
	
	// insert datepicker
	if ( $('#datestarttext').length && $('#dateendtext').length ) {
		// $('#datestarttext').iidatepicker({showTime: true, endID: "dateendtext"});
		// $('#dateendtext').iidatepicker({showTime: true, startID: "datestarttext"});
	}
	
	// Start ticker
	startTicker();
	
	// if the header is fixed then the container needs to move 48 pixels down
	// because the map and ticker will move under the header
	if ($('header').hasClass('fixed_header')) {
		$('#container').css('padding-top', $('header').height()+'px');
	} else {
		$('#container').css('padding-top', '0px');
	}
	
	// insert tagmodule
	if ($('.listTags').length != 0) {
		$('.listTags').tagModule({'scriptLocation':'/autocomplete.php',
		                      'displayFunc' : displayTagLink,
		                      'removeTagHook' : removeTag,
		                      'spanTagClass' : 'list_item'});
	}
	
	document.onkeydown = function(e){
		var searchFocus = true;
		if ($("input, textarea").is(":focus")) {
			searchFocus = false;
		}
		if (searchFocus) {
			navigateKeys(e);
		}
	};
	
});

function startTicker() {
	// insert ticker
	var ticker = document.getElementById('ticker');
	if ( ticker !== null ) {
		var headLines = ticker.childNodes;
		// 2/3de scherm beginnen
		var totalWidth = ticker.offsetWidth - (ticker.offsetWidth * 0.33);
		
		var headLinesLength = headLines.length;
		for (var i=0; i<headLinesLength; i++) {
			if (headLines[i].nodeType == 1) {
				headLines[i].style.left = totalWidth+'px';
				totalWidth += headLines[i].offsetWidth + 7;
			}
		}
		
		setInterval( function() {
			for (var i=0; i<headLinesLength; i++) {
				if  (headLines[i].nodeType == 1) {
					headLines[i].style.left = (headLines[i].offsetLeft - 1)+'px';
					if (headLines[i].offsetLeft * -1 > headLines[i].offsetWidth) {
						headLines[i].style.left = $(window).width()+'px';
					}
				}
			}
		}, 20);
	}
}

//replaces all timeplaceholders with a format
function replaceTimePlaceHolder() {

	var monthNames = ["Jan","Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];
	var dayNames   = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
	
	// reference - current values
	var currentTime        = createValidDate($('#dateNow').html());

	if (currentTime == null) {
		return;
	}

	var currentDayNumber   = zeroBeforeDate(currentTime.getDate()); // from 1 to 31
	var currentYear        = currentTime.getFullYear();
		
	$('.timePlaceholder').each(function() {
		
		var articleTime = createValidDate($(this).html()); // date of article
		
		// components of the date of this article
		
		var articleDay         = dayNames[articleTime.getDay()];
		var articleDayNumber   = zeroBeforeDate(articleTime.getDate()); // day of the month (from 1 to 31)

		var articleMinutes     = zeroBeforeDate(articleTime.getMinutes());
		var articleHour        = zeroBeforeDate(articleTime.getHours());
		
		var articleMonth       = monthNames[articleTime.getMonth()];
		var articleMonthNumber = zeroBeforeDate(articleTime.getMonth() + 1); // can't be 0, from 01 to 12
		
		var articleYear        = articleTime.getFullYear();
		
		// time ago
		var timeDiff    = Math.abs(articleTime.getTime() - currentTime.getTime()); // milliseconds

		var diffDays    = Math.floor(timeDiff / (1000 * 3600 * 24));
		var diffHours   = Math.floor(timeDiff / (1000 * 3600));
		
		var date = '';
		
		//check which format to show ( HH:mm, Day HH:mm, 12 Nov HH:mm, YYYY-MM-DD)
		if (currentYear != articleYear && diffDays > 60) {
			// YYYY-MM-DD
			date = articleYear + '-' + articleMonthNumber + '-' + articleDayNumber;
		} else if (diffDays > 4) {
			// 12 Nov HH:mm
			date = articleDayNumber + ' ' + articleMonth + ' ' + articleHour + ':' + articleMinutes;
		} else if (articleDayNumber != currentDayNumber) {
			// Day HH:mm
			date = articleDay + ' ' + articleHour + ':' + articleMinutes;
		} else if (diffHours > 0) {
			// HH:mm
			date = articleHour + ':' + articleMinutes;
		} else {
			// items within the last hour
			date = "<span class='redTime'>" + articleHour + ':' + articleMinutes + '<span>';
		}
		
		//put date in the placeholder
		$(this).html(date);
	});
	
}


//creates valid date from php date string
function createValidDate(date) {
	
	if (typeof date === 'string') {
		var t = date.split(/[- :]/);
		
		//when t[3], t[4] and t[5] are missing they defaults to zero
		return new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
	}
	
	return null;
}


function zeroBeforeDate(date) {
	if (date < 10) {
		return '0'+date;
	}
	return date;
}


function updatetime(articleid,time) {
	var minuten = Math.floor(time/60);
	var id = '#news' + articleid + ' .time_titel .update_time';
	if (time <= 59) {
		var time_sec = setInterval(function () {
			if(time == 59) {
				$(id).html('1 min geleden');
				clearInterval(time_sec);
				updatetime(articleid, time);
			} else {
				time = time + 1;
				$(id).html(time + ' sec geleden');
			}
		}, 1000);
	} else {
		var time_min = setInterval(function () {
			time = time + 30;
			var minuten = Math.floor(time/60);
			if(minuten == 60) {
				$(id).html('1 uur geleden');
				clearInterval(time_min);
			} else {
				$(id).html(minuten + ' min geleden');
			}
		}, 30000); 
	}
}

var mailnr = 0;
function changenewmail(value) {
	if (value == 99){
		mailnr = 0;
	}else if(mailnr < 4) {
		if(mailnr == value) {
			mailnr++;
			$('.share_mails').append("<input type='email' onkeypress='changenewmail(" + mailnr + 
			  ")' onpaste='changenewmail(" + mailnr + ")' class='toShareMail' " +
			  " id='toShareMail" + mailnr +"' placeholder='Email adres'>\n");
		}
	}
	
}

//sessies en dagen met linker en rechter pijltoets besturen
function navigateKeys(e) {
	
	var keycode = e.which;
	
	var KEY_ARROW_LEFT  = 37;
	var KEY_ARROW_RIGHT = 39;
	var KEY_ALT         = 18;
	var KEY_ONE         = 49;
	var KEY_TWO         = 50;
	var KEY_THREE       = 51;
	
	//links
	if (keycode == KEY_ARROW_LEFT && document.getElementById('navigate-left') !== null) {
		document.getElementById('navigate-left').click();
		return;
	}
	
	//rechts
	if (keycode == KEY_ARROW_RIGHT && document.getElementById('navigate-right') !== null) {
		document.getElementById('navigate-right').click();
		return;
	}
	
	//alt+links
	if (e.altKey && keycode == KEY_TWO && document.getElementById('navigate-left') !== null) {
		document.getElementById('navigate-left').click();
		return;
	}
	
	//links
	if (keycode == KEY_TWO && document.getElementById('navigate-left') !== null) {
		document.getElementById('navigate-left').click();
		return;
	}
	
	//alt+rechts
	if (e.altKey && keycode == KEY_THREE && document.getElementById('navigate-right') !== null) {
		document.getElementById('navigate-right').click();
		return;
	}
	
	//rechts
	if (keycode == KEY_THREE && document.getElementById('navigate-right') !== null) {
		document.getElementById('navigate-right').click();
		return;
	}
	
	//alt+home
	if (e.altKey && keycode == KEY_ONE && document.getElementById('navigate-home') !== null) {
		document.getElementById('navigate-home').click();
		return;
	}
	
	//home
	if (keycode == KEY_ONE && document.getElementById('navigate-home') !== null) {
		document.getElementById('navigate-home').click();
		return;
	}
}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
